import { render, staticRenderFns } from "./MainDialog.vue?vue&type=template&id=8594879c&scoped=true"
import script from "./MainDialog.vue?vue&type=script&lang=js"
export * from "./MainDialog.vue?vue&type=script&lang=js"
import style0 from "./MainDialog.vue?vue&type=style&index=0&id=8594879c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8594879c",
  null
  
)

export default component.exports